/**
 * Generated from PostcardTokyo1Layout.fla
 */
export function PostcardTokyo1Layout(this: IPostcardTokyo1Layout) {
	const main = this.main;
	PostcardTokyo1Layout_main.call(this.main);
	main.x = 1024;
	main.y = 768;
	if (main.onLayout) main.onLayout();
	return this;
}
export function PostcardTokyo1Layout_main(this: IPostcardTokyo1Layout_main) {
	const postcard = this.postcard;
	PostcardTokyo1Layout_postcard.call(this.postcard);
	postcard.x = 0;
	postcard.y = 4.7;
	if (postcard.scale) postcard.scale.x = 0.633;
	if (postcard.scale) postcard.scale.y = 0.633;
	if (postcard.onLayout) postcard.onLayout();
	return this;
}
function PostcardTokyo1Layout_postcard(this: IPostcardTokyo1Layout_postcard) {
	const cardTransform = this.cardTransform;
	if (!cardTransform[0] && cardTransform.elementFactory) {
		cardTransform[0] = cardTransform.elementFactory(0,undefined);
	}
	if (cardTransform[0]) {
		PostcardTokyo1Layout_cardTransform1.call(cardTransform[0] as IPostcardTokyo1Layout_cardTransform1);
		cardTransform[0].x = -518.25;
		cardTransform[0].y = 477.2;
		cardTransform[0].width = 530.37;
		cardTransform[0].height = 664.81;
		if (cardTransform[0].onLayout) cardTransform[0].onLayout();
	}
	if (!cardTransform[1] && cardTransform.elementFactory) {
		cardTransform[1] = cardTransform.elementFactory(1,undefined);
	}
	if (cardTransform[1]) {
		PostcardTokyo1Layout_cardTransform2.call(cardTransform[1] as IPostcardTokyo1Layout_cardTransform2);
		cardTransform[1].x = -249.15;
		cardTransform[1].y = -183.55;
		cardTransform[1].width = 716.30;
		cardTransform[1].height = 897.86;
		if (cardTransform[1].onLayout) cardTransform[1].onLayout();
	}
	if (!cardTransform[2] && cardTransform.elementFactory) {
		cardTransform[2] = cardTransform.elementFactory(2,undefined);
	}
	if (cardTransform[2]) {
		PostcardTokyo1Layout_cardTransform3.call(cardTransform[2] as IPostcardTokyo1Layout_cardTransform3);
		cardTransform[2].x = -360.45;
		cardTransform[2].y = -440.75;
		cardTransform[2].width = 604.52;
		cardTransform[2].height = 757.76;
		if (cardTransform[2].onLayout) cardTransform[2].onLayout();
	}
	if (!cardTransform[3] && cardTransform.elementFactory) {
		cardTransform[3] = cardTransform.elementFactory(3,undefined);
	}
	if (cardTransform[3]) {
		PostcardTokyo1Layout_cardTransform4.call(cardTransform[3] as IPostcardTokyo1Layout_cardTransform4);
		cardTransform[3].x = 39;
		cardTransform[3].y = 252;
		cardTransform[3].width = 853.26;
		cardTransform[3].height = 1079.80;
		if (cardTransform[3].onLayout) cardTransform[3].onLayout();
	}
	if (!cardTransform[4] && cardTransform.elementFactory) {
		cardTransform[4] = cardTransform.elementFactory(4,undefined);
	}
	if (cardTransform[4]) {
		PostcardTokyo1Layout_cardTransform5.call(cardTransform[4] as IPostcardTokyo1Layout_cardTransform5);
		cardTransform[4].x = 287.35;
		cardTransform[4].y = -348.4;
		cardTransform[4].width = 439.49;
		cardTransform[4].height = 550.89;
		if (cardTransform[4].onLayout) cardTransform[4].onLayout();
	}
	if (!cardTransform[5] && cardTransform.elementFactory) {
		cardTransform[5] = cardTransform.elementFactory(5,undefined);
	}
	if (cardTransform[5]) {
		PostcardTokyo1Layout_cardTransform6.call(cardTransform[5] as IPostcardTokyo1Layout_cardTransform6);
		cardTransform[5].x = -646.8;
		cardTransform[5].y = 27.45;
		cardTransform[5].width = 515.32;
		cardTransform[5].height = 645.93;
		if (cardTransform[5].onLayout) cardTransform[5].onLayout();
	}
	if (!cardTransform[6] && cardTransform.elementFactory) {
		cardTransform[6] = cardTransform.elementFactory(6,undefined);
	}
	if (cardTransform[6]) {
		PostcardTokyo1Layout_cardTransform7.call(cardTransform[6] as IPostcardTokyo1Layout_cardTransform7);
		cardTransform[6].x = 273;
		cardTransform[6].y = 14.45;
		cardTransform[6].width = 665.31;
		cardTransform[6].height = 833.95;
		if (cardTransform[6].onLayout) cardTransform[6].onLayout();
	}
	if (!cardTransform[7] && cardTransform.elementFactory) {
		cardTransform[7] = cardTransform.elementFactory(7,undefined);
	}
	if (cardTransform[7]) {
		PostcardTokyo1Layout_cardTransform8.call(cardTransform[7] as IPostcardTokyo1Layout_cardTransform8);
		cardTransform[7].x = 648.35;
		cardTransform[7].y = -208.4;
		cardTransform[7].width = 692.50;
		cardTransform[7].height = 868.03;
		if (cardTransform[7].onLayout) cardTransform[7].onLayout();
	}
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"dependsOn":0,"outlineGlow":true,"outlineGlowUnder":true});
	}
	if (items[0]) {
		PostcardTokyo1Layout_pieces2.call(items[0] as IPostcardTokyo1Layout_pieces2);
		(items[0] as IPostcardTokyo1Layout_pieces2).dependsOn = 0;
		(items[0] as IPostcardTokyo1Layout_pieces2).outlineGlow = true;
		(items[0] as IPostcardTokyo1Layout_pieces2).outlineGlowUnder = true;
		items[0].x = -234.75;
		items[0].y = -94.4;
		items[0].width = 1722.95;
		items[0].height = 902.97;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,undefined);
	}
	if (items[1]) {
		PostcardTokyo1Layout_outlines2.call(items[1] as IPostcardTokyo1Layout_outlines2);
		items[1].x = -227.35;
		items[1].y = -156.5;
		items[1].width = 817.00;
		items[1].height = 227.00;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,undefined);
	}
	if (items[2]) {
		PostcardTokyo1Layout_pieces5.call(items[2] as IPostcardTokyo1Layout_pieces5);
		items[2].x = 297.4;
		items[2].y = -378.4;
		items[2].width = 289.00;
		items[2].height = 900.00;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,undefined);
	}
	if (items[3]) {
		PostcardTokyo1Layout_outlines5.call(items[3] as IPostcardTokyo1Layout_outlines5);
		items[3].x = 298.35;
		items[3].y = -375.1;
		items[3].width = 270.00;
		items[3].height = 179.00;
		if (items[3].onLayout) items[3].onLayout();
	}
	if (!items[4] && items.elementFactory) {
		items[4] = items.elementFactory(4,undefined);
	}
	if (items[4]) {
		PostcardTokyo1Layout_decorations3.call(items[4] as IPostcardTokyo1Layout_decorations3);
		items[4].x = -1.75;
		items[4].y = 157.7;
		items[4].width = 1732.00;
		items[4].height = 673.00;
		if (items[4].onLayout) items[4].onLayout();
	}
	if (!items[5] && items.elementFactory) {
		items[5] = items.elementFactory(5,undefined);
	}
	if (items[5]) {
		PostcardTokyo1Layout_pieces6.call(items[5] as IPostcardTokyo1Layout_pieces6);
		items[5].x = -630.3;
		items[5].y = 102.45;
		items[5].width = 595.00;
		items[5].height = 540.00;
		if (items[5].onLayout) items[5].onLayout();
	}
	if (!items[6] && items.elementFactory) {
		items[6] = items.elementFactory(6,undefined);
	}
	if (items[6]) {
		PostcardTokyo1Layout_outlines6.call(items[6] as IPostcardTokyo1Layout_outlines6);
		items[6].x = -594.45;
		items[6].y = 96.45;
		items[6].width = 586.00;
		items[6].height = 528.00;
		if (items[6].onLayout) items[6].onLayout();
	}
	if (!items[7] && items.elementFactory) {
		items[7] = items.elementFactory(7,undefined);
	}
	if (items[7]) {
		PostcardTokyo1Layout_pieces3.call(items[7] as IPostcardTokyo1Layout_pieces3);
		items[7].x = -402.1;
		items[7].y = -446.85;
		items[7].width = 740.00;
		items[7].height = 193.00;
		if (items[7].onLayout) items[7].onLayout();
	}
	if (!items[8] && items.elementFactory) {
		items[8] = items.elementFactory(8,undefined);
	}
	if (items[8]) {
		PostcardTokyo1Layout_outlines3.call(items[8] as IPostcardTokyo1Layout_outlines3);
		items[8].x = -347.95;
		items[8].y = -462.5;
		items[8].width = 439.00;
		items[8].height = 116.00;
		if (items[8].onLayout) items[8].onLayout();
	}
	if (!items[9] && items.elementFactory) {
		items[9] = items.elementFactory(9,{"dependsOn":0,"outlineGlow":true});
	}
	if (items[9]) {
		PostcardTokyo1Layout_pieces7.call(items[9] as IPostcardTokyo1Layout_pieces7);
		(items[9] as IPostcardTokyo1Layout_pieces7).dependsOn = 0;
		(items[9] as IPostcardTokyo1Layout_pieces7).outlineGlow = true;
		items[9].x = 193.4;
		items[9].y = 32.8;
		items[9].width = 692.00;
		items[9].height = 609.00;
		if (items[9].onLayout) items[9].onLayout();
	}
	if (!items[10] && items.elementFactory) {
		items[10] = items.elementFactory(10,undefined);
	}
	if (items[10]) {
		PostcardTokyo1Layout_outlines7.call(items[10] as IPostcardTokyo1Layout_outlines7);
		items[10].x = 277.35;
		items[10].y = 39.8;
		items[10].width = 542.00;
		items[10].height = 370.00;
		if (items[10].onLayout) items[10].onLayout();
	}
	if (!items[11] && items.elementFactory) {
		items[11] = items.elementFactory(11,undefined);
	}
	if (items[11]) {
		PostcardTokyo1Layout_pieces8.call(items[11] as IPostcardTokyo1Layout_pieces8);
		items[11].x = 659.95;
		items[11].y = -140.9;
		items[11].width = 277.00;
		items[11].height = 849.00;
		if (items[11].onLayout) items[11].onLayout();
	}
	if (!items[12] && items.elementFactory) {
		items[12] = items.elementFactory(12,undefined);
	}
	if (items[12]) {
		PostcardTokyo1Layout_outlines8.call(items[12] as IPostcardTokyo1Layout_outlines8);
		items[12].x = 675.3;
		items[12].y = -140.2;
		items[12].width = 276.00;
		items[12].height = 849.00;
		if (items[12].onLayout) items[12].onLayout();
	}
	if (!items[13] && items.elementFactory) {
		items[13] = items.elementFactory(13,undefined);
	}
	if (items[13]) {
		PostcardTokyo1Layout_decorations1.call(items[13] as IPostcardTokyo1Layout_decorations1);
		items[13].x = -3;
		items[13].y = 361.6;
		items[13].width = 1729.00;
		items[13].height = 530.00;
		if (items[13].onLayout) items[13].onLayout();
	}
	if (!items[14] && items.elementFactory) {
		items[14] = items.elementFactory(14,undefined);
	}
	if (items[14]) {
		PostcardTokyo1Layout_pieces4.call(items[14] as IPostcardTokyo1Layout_pieces4);
		items[14].x = 117.5;
		items[14].y = 363.45;
		items[14].width = 1124.00;
		items[14].height = 193.00;
		if (items[14].onLayout) items[14].onLayout();
	}
	if (!items[15] && items.elementFactory) {
		items[15] = items.elementFactory(15,undefined);
	}
	if (items[15]) {
		PostcardTokyo1Layout_outlines4.call(items[15] as IPostcardTokyo1Layout_outlines4);
		items[15].x = 293.75;
		items[15].y = 361.25;
		items[15].width = 1115.00;
		items[15].height = 193.00;
		if (items[15].onLayout) items[15].onLayout();
	}
	if (!items[16] && items.elementFactory) {
		items[16] = items.elementFactory(16,undefined);
	}
	if (items[16]) {
		PostcardTokyo1Layout_decorations2.call(items[16] as IPostcardTokyo1Layout_decorations2);
		items[16].x = -6.1;
		items[16].y = 520.9;
		items[16].width = 1725.00;
		items[16].height = 220.00;
		if (items[16].onLayout) items[16].onLayout();
	}
	if (!items[17] && items.elementFactory) {
		items[17] = items.elementFactory(17,{"dependsOn":0,"outlineGlow":true});
	}
	if (items[17]) {
		PostcardTokyo1Layout_pieces1.call(items[17] as IPostcardTokyo1Layout_pieces1);
		(items[17] as IPostcardTokyo1Layout_pieces1).dependsOn = 0;
		(items[17] as IPostcardTokyo1Layout_pieces1).outlineGlow = true;
		items[17].x = -515.95;
		items[17].y = 486.15;
		items[17].width = 449.00;
		items[17].height = 166.00;
		if (items[17].onLayout) items[17].onLayout();
	}
	if (!items[18] && items.elementFactory) {
		items[18] = items.elementFactory(18,undefined);
	}
	if (items[18]) {
		PostcardTokyo1Layout_outlines1.call(items[18] as IPostcardTokyo1Layout_outlines1);
		items[18].x = -514.75;
		items[18].y = 483.8;
		items[18].width = 446.00;
		items[18].height = 162.00;
		if (items[18].onLayout) items[18].onLayout();
	}
	const shapes = this.shapes;
	if (!shapes[0] && shapes.elementFactory) {
		shapes[0] = shapes.elementFactory(0,undefined);
	}
	if (shapes[0]) {
		shapes[0] = [5.00,0.00];
	}
	if (!shapes[1] && shapes.elementFactory) {
		shapes[1] = shapes.elementFactory(1,undefined);
	}
	if (shapes[1]) {
		shapes[1] = [-155.50,-282.95,-1.80,-174.50,121.50,-104.30,243.95,-55.95,251.00,242.85,-648.10,235.65,-645.50,-73.85,-488.65,-155.00,-405.15,-218.20,-341.95,-275.15];
	}
	if (!shapes[2] && shapes.elementFactory) {
		shapes[2] = shapes.elementFactory(2,undefined);
	}
	if (shapes[2]) {
		shapes[2] = [10.00,0.00];
	}
	if (!shapes[3] && shapes.elementFactory) {
		shapes[3] = shapes.elementFactory(3,undefined);
	}
	if (shapes[3]) {
		shapes[3] = [10.00,0.00];
	}
	if (!shapes[4] && shapes.elementFactory) {
		shapes[4] = shapes.elementFactory(4,undefined);
	}
	if (shapes[4]) {
		shapes[4] = [10.00,0.00];
	}
	if (!shapes[5] && shapes.elementFactory) {
		shapes[5] = shapes.elementFactory(5,undefined);
	}
	if (shapes[5]) {
		shapes[5] = [-600.10,-174.40,-544.45,-117.80,-537.60,8.15,-496.60,25.75,-467.35,134.15,-438.20,167.90,-348.40,173.75,-346.30,271.00,-628.45,356.75,-856.90,365.55,-864.70,224.95,-849.10,181.00,-816.90,161.45,-794.40,123.40,-787.60,22.80,-751.45,7.25,-742.65,-34.75,-738.70,-108.00,-693.80,-173.40];
	}
	const background = this.background;
	PostcardTokyo1Layout_background.call(this.background);
	background.x = 0;
	background.y = 0;
	background.width = 1790.00;
	background.height = 1325.00;
	if (background.onLayout) background.onLayout();
	const postcardOverlay = this.postcardOverlay;
	PostcardTokyo1Layout_postcardOverlay.call(this.postcardOverlay);
	postcardOverlay.x = 0;
	postcardOverlay.y = 0;
	postcardOverlay.width = 1784.00;
	postcardOverlay.height = 1318.00;
	if (postcardOverlay.onLayout) postcardOverlay.onLayout();
	const postcardMask = this.postcardMask;
	postcardMask.push(11.60,-642.40,878.60,-641.10,869.70,11.90,875.65,626.30,29.70,629.25,-492.65,638.15,-880.20,652.65,-875.55,-47.50,-881.50,-655.95);
	return this;
}
function PostcardTokyo1Layout_background(this: IPostcardTokyo1Layout_background) {
	if (this.setLayoutTexture) this.setLayoutTexture("postcard-tokyo-1.png", 0.500, 0.500);
	return this;
}
function PostcardTokyo1Layout_cardTransform2(this: IPostcardTokyo1Layout_cardTransform2) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-tokyo-1-2.png", 0.500, 0.501);
	return this;
}
function PostcardTokyo1Layout_cardTransform8(this: IPostcardTokyo1Layout_cardTransform8) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-tokyo-1-8.png", 0.500, 0.501);
	return this;
}
function PostcardTokyo1Layout_cardTransform3(this: IPostcardTokyo1Layout_cardTransform3) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-tokyo-1-3.png", 0.500, 0.501);
	return this;
}
function PostcardTokyo1Layout_cardTransform5(this: IPostcardTokyo1Layout_cardTransform5) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-tokyo-1-5.png", 0.500, 0.501);
	return this;
}
function PostcardTokyo1Layout_cardTransform6(this: IPostcardTokyo1Layout_cardTransform6) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-tokyo-1-6.png", 0.500, 0.501);
	return this;
}
function PostcardTokyo1Layout_cardTransform7(this: IPostcardTokyo1Layout_cardTransform7) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-tokyo-1-7.png", 0.500, 0.501);
	return this;
}
function PostcardTokyo1Layout_cardTransform4(this: IPostcardTokyo1Layout_cardTransform4) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-tokyo-1-4.png", 0.500, 0.501);
	return this;
}
function PostcardTokyo1Layout_cardTransform1(this: IPostcardTokyo1Layout_cardTransform1) {
	if (this.setLayoutTexture) this.setLayoutTexture("card-tokyo-1-1.png", 0.500, 0.501);
	return this;
}
function PostcardTokyo1Layout_pieces2(this: IPostcardTokyo1Layout_pieces2) {
	if (this.setLayoutTexture) this.setLayoutTexture("piece-tokyo-1-2.png", 0.364, 0.202);
	return this;
}
function PostcardTokyo1Layout_outlines2(this: IPostcardTokyo1Layout_outlines2) {
	if (this.setLayoutTexture) this.setLayoutTexture("outline-tokyo-1-2.png", 0.501, 0.502);
	return this;
}
function PostcardTokyo1Layout_pieces5(this: IPostcardTokyo1Layout_pieces5) {
	if (this.setLayoutTexture) this.setLayoutTexture("piece-tokyo-1-5.png", 0.526, 0.106);
	return this;
}
function PostcardTokyo1Layout_outlines5(this: IPostcardTokyo1Layout_outlines5) {
	if (this.setLayoutTexture) this.setLayoutTexture("outline-tokyo-1-5.png", 0.500, 0.503);
	return this;
}
function PostcardTokyo1Layout_decorations3(this: IPostcardTokyo1Layout_decorations3) {
	if (this.setLayoutTexture) this.setLayoutTexture("decoration-tokyo-1-3.png", 0.500, 0.501);
	return this;
}
function PostcardTokyo1Layout_pieces6(this: IPostcardTokyo1Layout_pieces6) {
	if (this.setLayoutTexture) this.setLayoutTexture("piece-tokyo-1-6.png", 0.402, 0.500);
	return this;
}
function PostcardTokyo1Layout_outlines6(this: IPostcardTokyo1Layout_outlines6) {
	if (this.setLayoutTexture) this.setLayoutTexture("outline-tokyo-1-6.png", 0.500, 0.500);
	return this;
}
function PostcardTokyo1Layout_pieces3(this: IPostcardTokyo1Layout_pieces3) {
	if (this.setLayoutTexture) this.setLayoutTexture("piece-tokyo-1-3.png", 0.631, 0.383);
	return this;
}
function PostcardTokyo1Layout_outlines3(this: IPostcardTokyo1Layout_outlines3) {
	if (this.setLayoutTexture) this.setLayoutTexture("outline-tokyo-1-3.png", 0.501, 0.500);
	return this;
}
function PostcardTokyo1Layout_pieces7(this: IPostcardTokyo1Layout_pieces7) {
	if (this.setLayoutTexture) this.setLayoutTexture("piece-tokyo-1-7.png", 0.379, 0.420);
	return this;
}
function PostcardTokyo1Layout_outlines7(this: IPostcardTokyo1Layout_outlines7) {
	if (this.setLayoutTexture) this.setLayoutTexture("outline-tokyo-1-7.png", 0.500, 0.500);
	return this;
}
function PostcardTokyo1Layout_pieces8(this: IPostcardTokyo1Layout_pieces8) {
	if (this.setLayoutTexture) this.setLayoutTexture("piece-tokyo-1-8.png", 0.448, 0.499);
	return this;
}
function PostcardTokyo1Layout_outlines8(this: IPostcardTokyo1Layout_outlines8) {
	if (this.setLayoutTexture) this.setLayoutTexture("outline-tokyo-1-8.png", 0.500, 0.501);
	return this;
}
function PostcardTokyo1Layout_decorations1(this: IPostcardTokyo1Layout_decorations1) {
	if (this.setLayoutTexture) this.setLayoutTexture("decoration-tokyo-1-1.png", 0.500, 0.500);
	return this;
}
function PostcardTokyo1Layout_pieces4(this: IPostcardTokyo1Layout_pieces4) {
	if (this.setLayoutTexture) this.setLayoutTexture("piece-tokyo-1-4.png", 0.341, 0.503);
	return this;
}
function PostcardTokyo1Layout_outlines4(this: IPostcardTokyo1Layout_outlines4) {
	if (this.setLayoutTexture) this.setLayoutTexture("outline-tokyo-1-4.png", 0.500, 0.503);
	return this;
}
function PostcardTokyo1Layout_decorations2(this: IPostcardTokyo1Layout_decorations2) {
	if (this.setLayoutTexture) this.setLayoutTexture("decoration-tokyo-1-2.png", 0.500, 0.500);
	return this;
}
function PostcardTokyo1Layout_pieces1(this: IPostcardTokyo1Layout_pieces1) {
	if (this.setLayoutTexture) this.setLayoutTexture("piece-tokyo-1-1.png", 0.501, 0.500);
	return this;
}
function PostcardTokyo1Layout_outlines1(this: IPostcardTokyo1Layout_outlines1) {
	if (this.setLayoutTexture) this.setLayoutTexture("outline-tokyo-1-1.png", 0.500, 0.500);
	return this;
}
function PostcardTokyo1Layout_shapes1(this: IPostcardTokyo1Layout_shapes1) {
	return this;
}
function PostcardTokyo1Layout_shapes2(this: IPostcardTokyo1Layout_shapes2) {
	return this;
}
function PostcardTokyo1Layout_shapes3(this: IPostcardTokyo1Layout_shapes3) {
	return this;
}
function PostcardTokyo1Layout_shapes4(this: IPostcardTokyo1Layout_shapes4) {
	return this;
}
function PostcardTokyo1Layout_shapes5(this: IPostcardTokyo1Layout_shapes5) {
	return this;
}
function PostcardTokyo1Layout_shapes6(this: IPostcardTokyo1Layout_shapes6) {
	return this;
}
function PostcardTokyo1Layout_postcardOverlay(this: IPostcardTokyo1Layout_postcardOverlay) {
	if (this.setLayoutTexture) this.setLayoutTexture("postcard-border.png", 0.500, 0.500);
	return this;
}
function PostcardTokyo1Layout_postcardMask(this: IPostcardTokyo1Layout_postcardMask) {
	return this;
}
interface IPostcardTokyo1LayoutArray<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface IPostcardTokyo1LayoutContainer {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface IPostcardTokyo1LayoutSprite extends IPostcardTokyo1LayoutContainer {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
}
interface IPostcardTokyo1LayoutText extends IPostcardTokyo1LayoutContainer {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface IPostcardTokyo1LayoutPolygon extends Array<number> {
}
interface IPostcardTokyo1Layout {
	readonly main: IPostcardTokyo1Layout_main;
}
interface IPostcardTokyo1Layout_main extends IPostcardTokyo1LayoutContainer {
	readonly postcard: IPostcardTokyo1Layout_postcard;
}
interface IPostcardTokyo1Layout_postcard extends IPostcardTokyo1LayoutContainer {
	readonly cardTransform: IPostcardTokyo1LayoutArray<IPostcardTokyo1Layout_cardTransform1|IPostcardTokyo1Layout_cardTransform2|IPostcardTokyo1Layout_cardTransform3|IPostcardTokyo1Layout_cardTransform4|IPostcardTokyo1Layout_cardTransform5|IPostcardTokyo1Layout_cardTransform6|IPostcardTokyo1Layout_cardTransform7|IPostcardTokyo1Layout_cardTransform8>;
	readonly items: IPostcardTokyo1LayoutArray<IPostcardTokyo1Layout_pieces2|IPostcardTokyo1Layout_outlines2|IPostcardTokyo1Layout_pieces5|IPostcardTokyo1Layout_outlines5|IPostcardTokyo1Layout_decorations3|IPostcardTokyo1Layout_pieces6|IPostcardTokyo1Layout_outlines6|IPostcardTokyo1Layout_pieces3|IPostcardTokyo1Layout_outlines3|IPostcardTokyo1Layout_pieces7|IPostcardTokyo1Layout_outlines7|IPostcardTokyo1Layout_pieces8|IPostcardTokyo1Layout_outlines8|IPostcardTokyo1Layout_decorations1|IPostcardTokyo1Layout_pieces4|IPostcardTokyo1Layout_outlines4|IPostcardTokyo1Layout_decorations2|IPostcardTokyo1Layout_pieces1|IPostcardTokyo1Layout_outlines1>;
	readonly shapes: IPostcardTokyo1LayoutArray<IPostcardTokyo1Layout_shapes1|IPostcardTokyo1Layout_shapes2|IPostcardTokyo1Layout_shapes3|IPostcardTokyo1Layout_shapes4|IPostcardTokyo1Layout_shapes5|IPostcardTokyo1Layout_shapes6>;
	readonly background: IPostcardTokyo1Layout_background;
	readonly postcardOverlay: IPostcardTokyo1Layout_postcardOverlay;
	readonly postcardMask: IPostcardTokyo1Layout_postcardMask;
}
interface IPostcardTokyo1Layout_background extends IPostcardTokyo1LayoutSprite {
}
interface IPostcardTokyo1Layout_cardTransform2 extends IPostcardTokyo1LayoutSprite {
}
interface IPostcardTokyo1Layout_cardTransform8 extends IPostcardTokyo1LayoutSprite {
}
interface IPostcardTokyo1Layout_cardTransform3 extends IPostcardTokyo1LayoutSprite {
}
interface IPostcardTokyo1Layout_cardTransform5 extends IPostcardTokyo1LayoutSprite {
}
interface IPostcardTokyo1Layout_cardTransform6 extends IPostcardTokyo1LayoutSprite {
}
interface IPostcardTokyo1Layout_cardTransform7 extends IPostcardTokyo1LayoutSprite {
}
interface IPostcardTokyo1Layout_cardTransform4 extends IPostcardTokyo1LayoutSprite {
}
interface IPostcardTokyo1Layout_cardTransform1 extends IPostcardTokyo1LayoutSprite {
}
interface IPostcardTokyo1Layout_pieces2 extends IPostcardTokyo1LayoutSprite {
	dependsOn: number;
	outlineGlow: boolean;
	outlineGlowUnder: boolean;
}
interface IPostcardTokyo1Layout_outlines2 extends IPostcardTokyo1LayoutSprite {
}
interface IPostcardTokyo1Layout_pieces5 extends IPostcardTokyo1LayoutSprite {
}
interface IPostcardTokyo1Layout_outlines5 extends IPostcardTokyo1LayoutSprite {
}
interface IPostcardTokyo1Layout_decorations3 extends IPostcardTokyo1LayoutSprite {
}
interface IPostcardTokyo1Layout_pieces6 extends IPostcardTokyo1LayoutSprite {
}
interface IPostcardTokyo1Layout_outlines6 extends IPostcardTokyo1LayoutSprite {
}
interface IPostcardTokyo1Layout_pieces3 extends IPostcardTokyo1LayoutSprite {
}
interface IPostcardTokyo1Layout_outlines3 extends IPostcardTokyo1LayoutSprite {
}
interface IPostcardTokyo1Layout_pieces7 extends IPostcardTokyo1LayoutSprite {
	dependsOn: number;
	outlineGlow: boolean;
}
interface IPostcardTokyo1Layout_outlines7 extends IPostcardTokyo1LayoutSprite {
}
interface IPostcardTokyo1Layout_pieces8 extends IPostcardTokyo1LayoutSprite {
}
interface IPostcardTokyo1Layout_outlines8 extends IPostcardTokyo1LayoutSprite {
}
interface IPostcardTokyo1Layout_decorations1 extends IPostcardTokyo1LayoutSprite {
}
interface IPostcardTokyo1Layout_pieces4 extends IPostcardTokyo1LayoutSprite {
}
interface IPostcardTokyo1Layout_outlines4 extends IPostcardTokyo1LayoutSprite {
}
interface IPostcardTokyo1Layout_decorations2 extends IPostcardTokyo1LayoutSprite {
}
interface IPostcardTokyo1Layout_pieces1 extends IPostcardTokyo1LayoutSprite {
	dependsOn: number;
	outlineGlow: boolean;
}
interface IPostcardTokyo1Layout_outlines1 extends IPostcardTokyo1LayoutSprite {
}
interface IPostcardTokyo1Layout_shapes1 extends IPostcardTokyo1LayoutPolygon {
}
interface IPostcardTokyo1Layout_shapes2 extends IPostcardTokyo1LayoutPolygon {
}
interface IPostcardTokyo1Layout_shapes3 extends IPostcardTokyo1LayoutPolygon {
}
interface IPostcardTokyo1Layout_shapes4 extends IPostcardTokyo1LayoutPolygon {
}
interface IPostcardTokyo1Layout_shapes5 extends IPostcardTokyo1LayoutPolygon {
}
interface IPostcardTokyo1Layout_shapes6 extends IPostcardTokyo1LayoutPolygon {
}
interface IPostcardTokyo1Layout_postcardOverlay extends IPostcardTokyo1LayoutSprite {
}
interface IPostcardTokyo1Layout_postcardMask extends IPostcardTokyo1LayoutPolygon {
}
